// extracted by mini-css-extract-plugin
export default {"container":"Popover_container--UG6","content":"Popover_content--Bbq","fullwidth":"Popover_fullwidth--PBK","fullHeight":"Popover_fullHeight--NDp"};